<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 20 20"
        :fill="color"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ color }"
    >
        <path
            d="M9.94231 11.0708C8.06538 11.0708 6.54231 9.55231 6.54231 7.67846C6.54231 5.80462 8.06538 4.28616 9.94231 4.28616C11.8192 4.28616 13.3423 5.80462 13.3423 7.67846C13.3423 9.55231 11.8192 11.0708 9.94231 11.0708ZM9.94231 2.47015e-06C5.69462 2.47015e-06 2.25 3.43846 2.25 7.67846C2.25 11.92 9.94231 20 9.94231 20C9.94231 20 17.6346 11.92 17.6346 7.67846C17.6326 5.64023 16.821 3.68628 15.3785 2.24633C13.936 0.806382 11.9805 -0.00163044 9.94231 2.47015e-06"
        ></path>
    </svg>
</template>

<script>
export default {
    name: 'PinSVG',
    props: {
        size: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
};
</script>

<style></style>
